// src/containers/VoucherPurchasePage/VoucherPurchasePage.js

import { React, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from '../../util/reactIntl';
import { compose } from 'redux';
import { NamedLink } from '../../components/NamedLink/NamedLink';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { loadData } from '../SearchPage/SearchPage.duck';
import OrderPanel from '../../components/OrderPanel/OrderPanel';
import { handleSsubmit, handleSubmit } from '../ListingPage/ListingPage.shared';
import { H4 } from '../PageBuilder/Primitives/Heading';
import { useConfiguration } from '../../context/configurationContext';
import UserCard from '../ListingPage/UserCard/UserCard';
import { types as sdkTypes } from '../../util/sdkLoader';
import { fetchTransactionLineItems } from './VoucherPurchasePage.duck';

import { setInitialValues } from './../ListingPage/ListingPage.duck';
import loadable from '@loadable/component';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import {
  LISTING_STATE_PENDING_APPROVAL,
  LISTING_STATE_CLOSED,
  propTypes,
} from '../../util/types';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
  NO_ACCESS_PAGE_USER_PENDING_APPROVAL,
  NO_ACCESS_PAGE_VIEW_LISTINGS,
} from '../../util/urlHelpers';

import Page from '../../components/Page/Page';
import LayoutSingleColumn from '../../components/LayoutComposer/LayoutSingleColumn/LayoutSingleColumn';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import UserNav from '../../components/UserNav/UserNav';
import { H1 } from '../../components/Heading/Heading';
const ProductOrderForm = loadable(() =>
  import(
    /* webpackChunkName: "ProductOrderForm" */ '../../components/OrderPanel/ProductOrderForm/ProductOrderForm'
  )
);

import css from './VoucherPurchasePage.module.css';
import { purchaseVoucher } from './VoucherPurchasePage.duck';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { initializeCardPaymentData } from '../../ducks/stripe.duck';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString, findRouteByRouteName } from '../../util/routes';
import { PrimaryButton } from '../../components';
const { UUID } = sdkTypes;

// --- SendToContainer ---
const SendToContainer = ({ form, setForm }) => (
  <div className={css.cardBox}>
    <h4 className={css.cardTitle}>
      <FormattedMessage
        id="VoucherPurchasePage.sendTo"
        defaultMessage="Send to:"
      />
    </h4>
    <input
      className={css.input}
      type="text"
      name="recipientName"
      placeholder="Recipient's name"
      value={form.recipientName}
      onChange={e => setForm({ ...form, recipientName: e.target.value })}
    />
    <input
      className={css.input}
      type="email"
      name="recipientEmail"
      placeholder="Recipient's email"
      value={form.recipientEmail}
      onChange={e => setForm({ ...form, recipientEmail: e.target.value })}
    />
    <label className={css.checkbox}>
      <input
        type="checkbox"
        name="acceptedTerms"
        checked={form.acceptedTerms}
        onChange={e => setForm({ ...form, acceptedTerms: e.target.checked })}
      />
      <span>
        I have read the{' '}
        <a
          href="https://findyourkind.com/help-support/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline', color: 'inherit' }}
        >
          Terms and Conditions
        </a>
        .
      </span>
    </label>
  </div>
);

const FromContainer = ({ form, setForm }) => (
  <div className={css.cardBox}>
    <h4 className={css.cardTitle}>
      <FormattedMessage id="VoucherPurchasePage.from" defaultMessage="From:" />
    </h4>
    <input
      className={css.input}
      type="text"
      name="senderName"
      placeholder="Your name"
      value={form.senderName}
      onChange={e => setForm({ ...form, senderName: e.target.value })}
    />
    <textarea
      className={css.textarea}
      name="message"
      placeholder="Enter a personal message (optional)"
      value={form.message}
      onChange={e => setForm({ ...form, message: e.target.value })}
    />
  </div>
);

const sessions = [
  { id: 1, label: '1 Session', hours: '2 Hours', price: '$120 AUD' },
  { id: 2, label: '2 Session', hours: '4 Hours', price: '$235 AUD' },
  { id: 3, label: '3 Session', hours: '6 Hours', price: '$349 AUD' },
  { id: 5, label: '5 Session', hours: '10 Hours', price: '$570 AUD' },
  { id: 10, label: '10 Session', hours: '20 Hours', price: '$1,080 AUD' },
];

export const VoucherPurchasePageComponent = props => {
  const [recipientName, setRecipientName] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const [senderName, setSenderName] = useState('');
  const [message, setMessage] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [selected, setSelected] = useState(null);
    const [emailError, setEmailError] = useState('');

  const history = useHistory();

  // Handler for dropdown selection
  const handleDropdownChange = (listingId) => {
    if (listingId) {
      const giftCard = giftCards.find(gc => gc.id.uuid === listingId);
      setSelected(listingId);
      setSelectedListing(giftCard);
      onFetchTransactionLineItems({
        orderData: { selected: listingId, quantity: 1 },
        listingId,
        isOwnListing: false,
      });
    }
  };
  const routes = useRouteConfiguration();

  const {
    currentUser,

    form,
    purchaseSuccess,
    scrollingDisabled,
    intl,
    getOwnListing,

    params,
    setForm,
 
    onFetchTransactionLineItems,

    listing,
    getListing,

    callSetInitialValues,
    onInitializeCardPaymentData,
    onManageDisableScrolling,
    routeConfiguration,

    onSubmitOrder,
    isOwnListing,
    showOwnListingsOnly,
    config,

    location,
    giftCards,
  } = props;

  const [selectedListing, setSelectedListing] = useState(null);

  const title = intl.formatMessage({
    id: 'VoucherPurchasePage.title',
    defaultMessage: 'Buy a Voucher',
  });
const emailIsValid = /\S+@\S+\.\S+/.test(recipientEmail);

const isFormComplete =
  !!selected &&
  recipientName.trim().length > 0 &&
  emailIsValid &&
  senderName.trim().length > 0 &&

  acceptedTerms;

  const onHandleSubmit = () => {
    const res = onFetchTransactionLineItems({
      orderData: {
        recipientName,
        recipientEmail,
        senderName,
        message,
        acceptedTerms,
        selected,
        // quantity: selectedHours,
      },
      listingId: selected,
      isOwnListing: false,
    });
  const submit = handleSsubmit({
    history,
    selected,
    currentUser,
    selectedListing,
    callSetInitialValues,
    onInitializeCardPaymentData,
    routes,
    preferSignupForAuth: true,
  });

  submit({recipientName,
      recipientEmail,
      senderName,
      message,
      acceptedTerms,
      selected,
quantity:1});

  }

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer />
            {/* <UserNav currentPage="VoucherPurchasePage" /> */}
          </>
        }
        footer={<FooterContainer />}
      >
        <div className={css.pageWrapper}>
          <div className={css.container}>
          <H1 className={css.header}>
            <FormattedMessage
              id="VoucherPurchasePage.header"
              defaultMessage={`Practical help when\n the village isn’t just\n down the road`}
            />
          </H1>
          <p className={css.voucherdescription}>
            <FormattedMessage
              id="VoucherPurchasePage.description"
              defaultMessage="You or your loved one will receive 2 hours of help per voucher, with whichever preferences are nominated. Services include laundry, ironing, home organisation, cleaning, meal preparation, child-care, gardening or dog walking."
            />
          </p>

          {/* Three Equal-Sized Numbered Steps */}
          <div className={css.stepsContainer}>
            {/* Step 1: Choose your Gift */}
            <div className={css.stepBox}>
              <div className={css.stepHeader}>
                <div className={css.stepNumber}>1</div>
                <h3 className={css.stepTitle}>
                  <FormattedMessage
                    id="VoucherPurchasePage.step1Title"
                    defaultMessage="Choose your Gift"
                  />
                </h3>
              </div>
              <div className={css.stepContent}>
                <select 
                  value={selected || ''} 
                  onChange={(e) => handleDropdownChange(e.target.value)}
                  className={css.giftSelect}
                >
                  <option value="" disabled>Select your gift package</option>
                  {giftCards
                    .sort((a, b) => a.attributes.price.amount - b.attributes.price.amount)
                    .map(giftCard => {
                      const { id, attributes } = giftCard;
                      const { title, description, price } = attributes;
                      const listingId = id.uuid;
                      
                      return (
                        <option key={listingId} value={listingId}>
                          {title} - {description} - ${price.amount/100} {price.currency}
                        </option>
                      );
                    })
                  }
                </select>
              </div>
            </div>

            {/* Step 2: Sent to */}
            <div className={css.stepBox}>
              <div className={css.stepHeader}>
                <div className={css.stepNumber}>2</div>
                <h3 className={css.stepTitle}>
                  <FormattedMessage
                    id="VoucherPurchasePage.step2Title"
                    defaultMessage="Sent to"
                  />
                </h3>
              </div>
              <div className={css.stepContent}>
                <label>Recipient's name</label>
                <input
                  type="text"
                  placeholder="Enter name"
                  value={recipientName}
                  onChange={e => setRecipientName(e.target.value)}
                  className={css.input}
                />
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Enter email address"
                  value={recipientEmail}
                  onChange={e => {
                    setRecipientEmail(e.target.value);
                    if (emailError) setEmailError(''); // clear error while typing
                  }}
                  onBlur={() => {
                    if (!/\S+@\S+\.\S+/.test(recipientEmail)) {
                      setEmailError('Please enter a valid email address.');
                    }
                  }}
                  className={css.input}
                />
                {emailError && <div className={css.errorText}>{emailError}</div>}
              </div>
            </div>

            {/* Step 3: From */}
            <div className={css.stepBox}>
              <div className={css.stepHeader}>
                <div className={css.stepNumber}>3</div>
                <h3 className={css.stepTitle}>
                  <FormattedMessage
                    id="VoucherPurchasePage.step3Title"
                    defaultMessage="From"
                  />
                </h3>
              </div>
              <div className={css.stepContent}>
                <label>Your name</label>
                <input
                  type="text"
                  placeholder="Enter your name"
                  value={senderName}
                  onChange={e => setSenderName(e.target.value)}
                  className={css.input}
                />
                <label>Personal Message</label>
                <textarea
                  placeholder="Enter a personal message up to 250 words."
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  className={css.textarea}
                />
              </div>
            </div>
          </div>

          {/* Terms and Conditions - Outside steps, above Buy button */}
          <div className={css.termsContainer}>
            <label className={css.termsRow}>
              <input
                type="checkbox"
                checked={acceptedTerms}
                onChange={e => setAcceptedTerms(e.target.checked)}
              />
              <span>
                I have read the{' '}
                <a
                  href="https://findyourkind.com/help-support/terms-and-conditions"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'underline', color: 'inherit', fontWeight: 'bold' }}
                >
                  Terms and Conditions
                </a>
                .
              </span>
            </label>
          </div>

          <PrimaryButton
            onClick={onHandleSubmit}
            disabled={!isFormComplete}
            className={css.nextToPayButton}
          >
            <FormattedMessage id="OrderPanel.ctaButtonMessagePurchase" />
          </PrimaryButton>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

// Redux state mapping
const mapStateToProps = state => {
  const { form, purchaseSuccess } = state.VoucherPurchasePage;
  const { currentUser } = state.user;
  const { currentPageResultIds } = state.VoucherPurchasePage;
  const giftCards = getListingsById(state, currentPageResultIds);

  return {
    form,
    purchaseSuccess,
    giftCards,
    scrollingDisabled: state.ui.scrollingDisabled,
    currentUser,
  };
};

// Redux dispatch mapping
const mapDispatchToProps = dispatch => ({
  onFetchTransactionLineItems: params =>
    dispatch(fetchTransactionLineItems(params)),
  setForm: form => dispatch({ type: 'SET_FORM', payload: form }),
 
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),

});

// Compose and export
const VoucherPurchasePage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(VoucherPurchasePageComponent);

export default VoucherPurchasePage;
